import { ReactNode } from 'react'
import * as React from 'react'
import cx from 'classnames'

import Styles from './GhostButton.module.scss'

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  disabled?: boolean
  onClick: (e: React.MouseEvent<HTMLElement>) => void
  type?: 'submit' | 'button'
}

export const GhostButton = ({ onClick, className, children, disabled, type = 'button', ...props }: Props) => {
  return (
    <button type={type} className={cx(Styles.ghostButton, className)} onClick={onClick} disabled={disabled} {...props}>
      {children}
    </button>
  )
}
